@use '@lib/assets/styles/main.scss' as *;

.homePageActions {
  display: flex;
  gap: 16px;
}
